import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNumberCircleOne = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8 14.5322C11.3137 14.5322 14 11.8459 14 8.53223C14 5.21852 11.3137 2.53223 8 2.53223C4.68629 2.53223 2 5.21852 2 8.53223C2 11.8459 4.68629 14.5322 8 14.5322Z",
		stroke: "currentColor",
		strokeMiterlimit: 10
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.75 6.78223L8.25 5.78223V11.5322",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgNumberCircleOne;
